import gql from "graphql-tag";
export const GET_GALLERY = gql`
query ($partnerType:jsonb!){
  Gallery(where: {visibleTo: {_contains: $partnerType}},order_by: {sequenceNo: asc}) {
    id
    imageUrl
    redirectUrl
  }
}`
